import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";
import {NgxIndexedDBService} from "ngx-indexed-db";
import {Order} from "../model/order";

export interface StorageChange {
  key: string;
  value: string;
  storageArea: "localStorage" | "sessionStorage";
}

export interface IndexDBChange{
  key:string;
  value: Order;
}

export interface StorageGetItem {
  key: string;
  storageArea: "localStorage" | "sessionStorage";
}

@Injectable({ providedIn: "root" })
export class StorageService {
  listening: boolean = false;
  listeningForOrderDetailsDownload: boolean = false;
  listeningForOrderObjectDownload: boolean = false;
  public storageChange$: ReplaySubject<StorageChange> = new ReplaySubject();
  public indexDBChange$: ReplaySubject<IndexDBChange> = new ReplaySubject<IndexDBChange>();


  constructor(private dbService: NgxIndexedDBService) {
    /*  const objectStoresMeta = { // hotfix for deleted indexDB
      store: 'orders',
      storeConfig: { keyPath: 'orderid', autoIncrement: true },
      storeSchema: [
        { name: 'name', keypath: 'name', options: { unique: false } },
      ]
    };
    this.dbService.clear('orders');
    this.dbService.createObjectStore(objectStoresMeta);*/
  }

  public async setIndexedDbItem(change: IndexDBChange){
    await this.dbService.update(change.key,change.value).subscribe();
    this.indexDBChange$.next(change);
    this.listening = false;
  }

  public setStorageItem(change: StorageChange): void {
    window[change.storageArea].setItem(change.key, change.value);
    this.storageChange$.next(change);
    this.listening = false;
  }

  public getStorageItem(getItem: StorageGetItem): void {
    window[getItem.storageArea].getItem(getItem.key);
  }
}
